export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15108.5512b123.jpg";